<template>
  <div>
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else>
      <v-layout row wrap>
        <v-flex class="xs12 sm4">
          <!-- Délai de d'attente -->
          <v-card height="300">
            <highcharts v-if="satisfactions.length" :options="optionsWaiting"></highcharts>
            <v-card-text v-else>{{ $tc('data', 0) + ' ' + $t('concerning') + ' : ' + $t('waitingTime') | cap }}</v-card-text>
          </v-card>
        </v-flex>
        <v-flex class="xs12 sm4">
          <!-- Qualité des réponses -->
          <v-card height="300">
            <highcharts v-if="satisfactions.length" :options="optionsQuality"></highcharts>
            <v-card-text v-else>{{ $tc('data', 0) + ' ' + $t('concerning') + ' : ' + $t('answersQuality') | cap }}</v-card-text>
          </v-card>
        </v-flex>
        <v-flex class="xs12 sm4">
          <!-- Qualité des réponses -->
          <v-card height="300">
            <highcharts v-if="satisfactions.length" :options="optionsWelcome"></highcharts>
            <v-card-text v-else>{{ $tc('data', 0) + ' ' + $t('concerning') + ' : ' + $t('advisorWelcome') | cap }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Détails des satisfactions -->
      <v-card class="mb-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6 sm10 class="headline">{{ $t('evaluationsDetails') }}</v-flex>
            <v-flex xs6 sm2>
              <v-btn color="primary" dark flat @click="download()">{{ $t('exportInCsv') }}<v-icon color="primary" right>file_download</v-icon></v-btn>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="satisfactions"
            :no-data-text="$tc('evaluations', 0)"
            :no-results-text="$tc('results', 0)"
            :rows-per-page-items="[10, 25, 50, { text: $tc('all', 2), value: -1 }]"
            :rows-per-page-text="$t('evaluationsPerPage')"
            :pagination.sync="pagination"
          >
            <template slot="headerCell" slot-scope="props" >
              <span>{{ props.header.text }}</span>
            </template>
            <template slot="items" slot-scope="props" >
              <td>{{ props.item.date | date}}</td>
              <td style="min-width: 120px; word-break: break-all;">{{ props.item.id}}</td>
              <td>
                <wz-rating v-if="props.item.waiting" :max="3" :rate="props.item.waiting"></wz-rating>
                <span v-else>{{ labels[0] }}</span>
              </td>
              <td>
                <wz-rating v-if="props.item.quality" :max="3" :rate="props.item.quality"></wz-rating>
                <span v-else>{{ labels[0] }}</span>
              </td>
              <td>
                <wz-rating v-if="props.item.welcome" :max="3" :rate="props.item.welcome"></wz-rating>
                <span v-else>{{ labels[0] }}</span>
              </td>
              <td>
                <div v-if="props.item.agent" class="alignIconeName">
                  <wz-avatar
                    :username="props.item.agent.USR_FIRST_NAME  + ' ' + props.item.agent.USR_LAST_NAME"
                    :src="`${domaine}/media/user/small/${props.item.agent.USR_ID}_avatar.jpg`"
                    size="35px"
                  ></wz-avatar>
                  <div>
                  <div class="ml-2">
                    {{ props.item.agent.USR_FIRST_NAME + ' ' + props.item.agent.USR_LAST_NAME }}
                  </div>
                  <div class="ml-2" v-if="(props.item.agent.USR_ID == $store.state._User.id)">
                    ({{ $t('me') }})
                  </div>
                </div>
                </div>
                <div v-else>
                  <wz-avatar
                    :src="`${domaine}/media/user/small/undefined_avatar.jpg`"
                    size="35px"
                  ></wz-avatar>
                </div>
              </td>
              <td style="min-width: 150px; word-break: break-all;">{{ props.item.site}}</td>
              <td class="text-xs-right px-0">
                <v-btn icon flat @click.stop="openDialogChat(props.item)">
                  <v-icon>forum</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>

    <!-- DIALOGUES -->
    <v-dialog
      v-model="dialogChat"
      persistent
      min-width="640px"
      max-width="800px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card flat>
        <v-card-title class="primary white--text"  style="height: 52px; padding: 0px;">
          <v-btn icon @click="cancelDialogChat()"><v-icon class="white--text">close</v-icon></v-btn>
          <span class="title"><!-- chat #{{ chatDialog.id }} --></span>
        </v-card-title>
          <v-card-text :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 210px);' : ''" class="pa-0">
            <wz-histo-chats
              v-if="chatDialog.id"
              :params="'visId=' + chatDialog.id"
              :numChatsTotal="String(0)"
              chatHeight="100%"
              type="satisfaction"
              scroll
            ></wz-histo-chats>
          </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import json2csv from 'json2csv'
import { mapGetters } from 'vuex'
import { DOMAINE } from '../../constants'
export default {

  name: 'Satisfaction',

  data () {
    return {
      domaine: DOMAINE,
      /**
       * Indique si la requête est en cours
       * @type {Boolean}
       */
      loading: false,
      evalWaiting: [],
      evalQuality: [],
      evalWelcome: [],
      dialogChat: false,
      chatDialog: {},
      /**
       * Options des graphiques
       */
      optionsPie: {
        chart: {
          height: 300,
          type: 'pie',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false
        },
        colors: [
          this.$vuetify.theme.tertiary,
          this.$vuetify.theme.error,
          this.$vuetify.theme.warning,
          this.$vuetify.theme.success
        ],
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },
      optionsWaiting: {
        title: { text: this.$t('questionWaitingTime') },
        series: [{ data: {} }]
      },
      optionsQuality: {
        title: { text: this.$t('questionAnswersQuality') },
        series: [{ data: {} }]
      },
      optionsWelcome: {
        title: { text: this.$t('questionAdvisorWelcome') },
        series: [{ data: {} }]
      },
      /**
       * Détails des évaluations
       */
      headers: [
        { text: 'Date', value: 'date', align: 'left' },
        { text: 'ID ' + this.$tc('visitors', 1, {count: ''}), value: 'id', align: 'left' },
        { text: _.upperFirst(this.$t('waitingTime')), value: 'waiting', align: 'left' },
        { text: _.upperFirst(this.$t('answersQuality')), value: 'quality', align: 'left' },
        { text: _.upperFirst(this.$t('advisorWelcome')), value: 'welcome', align: 'left' },
        { text: _.upperFirst(this.$tc('agents', 1, {count: ''})), value: 'agent', align: 'left' },
        { text: _.upperFirst(this.$tc('sites', 1, {count: ''})), value: 'site', align: 'left' },
        { text: _.upperFirst(this.$tc('chat')), value: 'chat', align: 'left' }
      ],
      satisfactions: [],
      /**
       * Libellés des réponses
       */
      labels: [
        this.$t('nsp'),
        this.$tc('satisfactions', 0),
        this.$tc('satisfactions', 1),
        this.$tc('satisfactions', 2)
      ],
      pagination: {
        sortBy: 'date',
        descending: true
      }
    }
  },

  created () {
    this.optionsWaiting = _.merge(this.optionsWaiting, this.optionsPie)
    this.optionsQuality = _.merge(this.optionsQuality, this.optionsPie)
    this.optionsWelcome = _.merge(this.optionsWelcome, this.optionsPie)
    this.getSatisfaction()
  },

  methods: {
    getSatisfaction () {
      this.loading = true
      this.satisfactions = []
      this.axios.get('get/satisfaction.php?' + this.params)
      .then(res => {
        // formatage du détails des évaluations
        // suppression des doublons
        res.data = _.uniqBy(res.data, 'SAT_VIS_SESSION_ID')
        _.each(res.data, s => {
          // console.log('usr', s.SAT_USR_ID)
          // console.log('data', moment(s.SAT_DATE).format('x'))
          let agent = s.SAT_USR_ID
            ? this.$store.getters['_User/getUserById'](s.SAT_USR_ID)
            : null
          let site = this.$store.getters['_Sites/GET_SITE_BY_ID'](s.SAT_LIC_ID) || s.SAT_LIC_ID
          // let evaluation = s.VIS_EVAL.split('|')
          this.satisfactions.push({
            date: moment(s.SAT_DATE).format('X'),
            id: s.SAT_VIS_SESSION_ID,
            waiting: Number(s.SAT_EVAL_Q2),
            quality: Number(s.SAT_EVAL_Q3),
            welcome: Number(s.SAT_EVAL_Q1),
            agent: agent,
            site: site.LIC_URL
          })
        })

        // Délai de d'attente
        this.evalWaiting = _.countBy(_.sortBy(_.map(this.satisfactions, s => {
          return s.waiting
        })))
        this.evalWaiting = this.fillEval(this.evalWaiting)
        // formatage afin de le représenter dans le graphique
        this.optionsWaiting.series[0].data = _.map(this.evalWaiting, (v, k) => {
          return {
            name: this.labels[k] + ' ' + v + '/' + this.satisfactions.length,
            y: _.round((v / this.satisfactions.length), 2)
          }
        })
        this.optionsWaiting.title.text = this.$t('questionWaitingTime') + ' (' + this.ratioWaiting + ' %)'

        // Qualité des réponses
        this.evalQuality = _.countBy(_.sortBy(_.map(this.satisfactions, s => {
          return s.quality
        })))
        this.evalQuality = this.fillEval(this.evalQuality)
        // formatage afin de le représenter dans le graphique
        this.optionsQuality.series[0].data = _.map(this.evalQuality, (v, k) => {
          return {
            name: this.labels[k] + ' ' + v + '/' + this.satisfactions.length,
            y: _.round((v / this.satisfactions.length), 2)
          }
        })
        this.optionsQuality.title.text = this.$t('questionAnswersQuality') + ' (' + this.ratioQuality + ' %)'

        // Qualité de l'accueil
        this.evalWelcome = _.countBy(_.sortBy(_.map(this.satisfactions, s => {
          return s.welcome
        })))
        this.evalWelcome = this.fillEval(this.evalWelcome)
        // formatage afin de le représenter dans le graphique
        this.optionsWelcome.series[0].data = _.map(this.evalWelcome, (v, k) => {
          return {
            name: this.labels[k] + ' ' + v + '/' + this.satisfactions.length,
            y: _.round((v / this.satisfactions.length), 2)
          }
        })
        this.optionsWelcome.title.text = this.$t('questionAdvisorWelcome') + ' (' + this.ratioWelcome + ' %)'
      })
      .catch(_ => {})
      .then(() => {
        this.loading = false
      })
    },

    fillEval (evalToFill) {
      return {
        0: evalToFill[0] || 0,
        1: evalToFill[1] || 0,
        2: evalToFill[2] || 0,
        3: evalToFill[3] || 0
      }
    },

    download () {
      let csv = null
      const fields = this.headers.map(h => h.value)
      const fieldNames = this.headers.map(h => h.text)
      const data = this.satisfactions.map(s => ({
        date: moment.unix(s.date).format(),
        id: s.id,
        waiting: s.waiting,
        quality: s.quality,
        welcome: s.welcome,
        agent: s.agent.USR_FIRST_NAME + ' ' + s.agent.USR_LAST_NAME,
        site: s.site
      }))
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }

      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'satisfaction.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    },
    /**
     * Dialogue d'édition d'un lead
     */
    openDialogChat (data) {
      console.log('dsata', data)
      this.dialogChat = true
      this.chatDialog = {}
      this.chatDialog = _.clone(data)
    },
    cancelDialogChat () {
      this.dialogChat = false
    }
  },

  computed: {
    ...mapGetters('_Stats', ['params']),
    ratioWaiting () {
      let moySatisfait = _.toInteger(this.evalWaiting[2])
      let satisfait = _.toInteger(this.evalWaiting[3])
      return _.round(((moySatisfait * 0.5 + satisfait) / this.nbWaiting) * 100, 2)
    },
    nbWaiting () {
      return this.satisfactions.length - _.toInteger(this.evalWaiting[0])
    },
    ratioQuality () {
      let moySatisfait = _.toInteger(this.evalQuality[2])
      let satisfait = _.toInteger(this.evalQuality[3])
      return _.round(((moySatisfait * 0.5 + satisfait) / this.nbQuality) * 100, 2)
    },
    nbQuality () {
      return this.satisfactions.length - _.toInteger(this.evalQuality[0])
    },
    ratioWelcome () {
      let moySatisfait = _.toInteger(this.evalWelcome[2])
      let satisfait = _.toInteger(this.evalWelcome[3])
      return _.round(((moySatisfait * 0.5 + satisfait) / this.nbWelcome) * 100, 2)
    },
    nbWelcome () {
      return this.satisfactions.length - _.toInteger(this.evalWelcome[0])
    }
  },

  filters: {
    date: function (v) {
      return moment.unix(v).format('llll')
    }
  },

  watch: {
    params (v) {
      this.getSatisfaction()
    }
  }
}
</script>
<style>
  .alignIconeName {display: -webkit-inline-box}
</style>



// WEBPACK FOOTER //
// src/components/stats/Satisfaction.vue